/**
 * Landing Page
 * Main marketing landing page for MerchMidas
 * Refactored: Sections extracted to @/components/landing
 */

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { SEO, PAGE_SEO } from "@/components/seo";
import {
  HeroSection,
  FeaturesSection,
  TestimonialsSection,
  PricingSection,
  CaseStudiesSection,
  FAQSection,
  CTASection,
} from "@/components/landing";

const Landing = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO {...PAGE_SEO.landing} />
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <TestimonialsSection />
      <PricingSection />
      <CaseStudiesSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default Landing;
